import authService from 'services/auth';
import formatter from 'helpers/formatter';

export const LOGIN_REQUEST = '@account/login-request';
export const LOGIN_SUCCESS = '@account/login-success';
export const LOGIN_FAILURE = '@account/login-failure';
export const SILENT_LOGIN = '@account/silent-login';
export const LOGOUT = '@account/logout';
export const REGISTER = '@account/register';
export const UPDATE_PROFILE = '@account/update-profile';

export function adminLogin(values: any) {
  return async (dispatch: any) => {
    try {
      dispatch({ type: LOGIN_REQUEST });

      await authService.adminLoginRails(values);
      const user = await authService.loginInWithToken();

      dispatch({
        type: LOGIN_SUCCESS,
        payload: {
          user
        }
      });
    } catch (error) {
      dispatch({ type: LOGIN_FAILURE });
      throw error;
    }
  };
}
export function login(email: any, password: any) {
  return async (dispatch: any) => {
    try {
      dispatch({ type: LOGIN_REQUEST });

      await authService.loginRails(email, password);
      const user = await authService.loginInWithToken();
      dispatch({
        type: LOGIN_SUCCESS,
        payload: {
          user
        }
      });
    } catch (error) {
      dispatch({ type: LOGIN_FAILURE });
      throw error;
    }
  };
}

export function EditPassword(password: any, passwordConfirmation: any, token: any) {
  return async () => {
    try {
      return await authService.EditPassword(password, passwordConfirmation, token);
    } catch (error) {
      throw error;
    }
  };
}
export function RecoverPassword(email: any) {
  return async () => {
    try {
      return await authService.recoverPassword(email);
    } catch (error) {
      throw error;
    }
  };
}

export function setUserData(user: any) {
  if (user) user.country = formatter.getCountry();
  return (dispatch: any) =>
    dispatch({
      type: SILENT_LOGIN,
      payload: {
        user
      }
    });
}

export function logout() {
  return async (dispatch: any) => {
    authService.logout();

    dispatch({
      type: LOGOUT
    });
  };
}

export function register() {
  return true;
}

export function updateProfile(data: any) {
  return (dispatch: any) => {
    dispatch({
      type: UPDATE_PROFILE,
      payload: { user: data }
    });
  };
}
